 <template>
    <el-select
        @change="SelectChange"
        size="mini"
        v-model="selectValue"
        :style="{ width: width, margin: margin }"
        placeholder="请选择流程"
        clearable>
        <el-option v-for="(item, idx) in select" :key="idx" :label="item.name" :value="item.id"></el-option>
    </el-select>
</template>
<script>
export default {
    props: {
        value: {
            type: [String, Array, Number],
            default: null
        },
        width: {
            type: String,
            default: '100%'
        },
        margin: {
            type: String,
            default: '0px'
        },
    },
    watch: {
        value () {
            this.selectValue = this.value
        }
    },
    data () {
        return {
            select: [],
            selectValue: null,
        }
    },
    mounted () {
        this.select = [{
            id: 1,
            name: '默认流程方案'
        }]
    },
    methods: {
        SelectChange(data) {
            this.$emit('input', data)
        }
    }
}
</script>